import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AuthService } from '../service/auth.service';

@Component({
  selector: 'app-company-interests',
  templateUrl: './company-interests.component.html',
  styleUrls: ['./company-interests.component.css']
})
export class CompanyInterestsComponent implements OnInit {

  authToken = localStorage.getItem('auth');

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'auth': `${this.authToken}` }),
    withCredentials: true,
  };

  businessID = this.route.snapshot.params.businessID;
  interests = [];
  opening;
  company = JSON.parse(localStorage.getItem('company_' + this.businessID));
  contacted_by = [];
  employer_lists = [];
  already_in_list = [];
  rights = [
    {
      highlighted: "Kaikilla",
      normal: " organisaatiossasi on oikeus nähdä profiili",
      icon_src: "../../assets/icons/people.svg",
      selected: false,
      id: 'all_in_organization',
      can_be_seen_by_others_in_same_business: true,
    },
    {
      highlighted: "Vain",
      normal: " sinulla on oikeus",
      icon_src: "../../assets/icons/lock_icon.svg",
      selected: false,
      id: 'only_me',
      can_be_seen_by_others_in_same_business: false,
    }
  ]
  storable_profile;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private http: HttpClient,
    private route: ActivatedRoute,
    private authService: AuthService) { }

  ngOnInit(): void {
    this.fetchCompanyInterests();
    console.log(this.company)
  }

  fetchCompanyInterests() {
    this.http.get(environment.BUSINESS_INTERESTS, this.httpOptions).subscribe(
      (res: any) => {
        if (res.status == 200) {
          console.log('company interests', res.message)
          this.interests = res.message;
        }
        else {
          console.log("Error while finding status :: ", res);
        }

      }, (err: any) => {

        console.log("Error while finding status :: ", err);
      })
  }

  routeProfile(data){
    this.router.navigate(['/'+this.businessID + '/wishlist/profile-opened/businessInterest/like/' + data._id])

  }

  fetchPublicProfile(data){


    this.http.get(environment.VALIDATE_HEADHUNTING_PROFILE + '/' + data._id, this.httpOptions).subscribe(
      (res: any) => {
        if(res.status == 200 ) {

          var obj = {
            profile: res.message[0]
          }

          var languages_obj_array = obj.profile.languages;
          var display_lang_str = "";
          var display_school_str = "";

          if(languages_obj_array.length > 0){
            for (let i = 0; i < languages_obj_array.length; i++) {
              var lang = languages_obj_array[i];
              console.log(lang);
              display_lang_str += lang.name_fi + ', ';
            }

                      //remove last comma
          display_lang_str = display_lang_str.slice(0, -2);
          obj.profile.display_lang = display_lang_str;

          }

          if(obj.profile.schools && obj.profile.schools.length > 0){
            for (let i = 0; i < obj.profile.schools.length; i++) {
              var school = obj.profile.schools[i];
              console.log(school);
              display_school_str += school.school_name + ', ';
            }

            //remove last comma
            display_school_str = display_school_str.slice(0, -2);
            obj.profile.display_school = display_school_str;

          }

          this.opening = obj;
          console.log(this.opening)

          console.log(res.message, this.opening.profile)
          document.getElementById('oc-profile').click();
          
        }
        else {
          console.log('buu')
          this.opening;
        }
        
      }, (err: any) => {

      }
    )
  }

  saveProfileToList(data) {
    console.log(data, 1);
    this.storable_profile = data;
    this.storable_profile.userID = data._id;
    this.already_in_list = [];


    this.http.get(environment.EMPLOYER_LISTS, this.httpOptions).subscribe(
      (res: any) => {
        if (res.status == 200) {
          this.employer_lists = res.message;
          document.getElementById('save-list').click();

          this.already_in_list = this.employer_lists
            .filter(item =>
              item.profiles && item.profiles.some(profile => profile._id === data.userID)
            )
            .map(item => ({
              id: item._id,
              name: item.name
            }));

          console.log(this.already_in_list, 2)
        }
        else {
          this.employer_lists = [];
          document.getElementById('save-list').click();
          console.log('buu')
        }

      }, (err: any) => {

      }
    )
  }

  saveToList() {
    var storable_profile = this.storable_profile;

    //find selected lists
    var selected_lists = this.employer_lists.filter(x => x.selected == true);
    console.log(selected_lists, storable_profile, 3);

    if (selected_lists.length == 0) {
      alert('Valitse lista');
      return;
    }

    //Check if profile is already in selected list
    var is_in_list = false;
    for (let i = 0; i < selected_lists.length; i++) {
      const list = selected_lists[i];
      if (list.profiles.some(profile => profile._id === storable_profile._id)) {
        is_in_list = true;
      }
    }

    if (is_in_list) {
      alert('Profiili on jo valitsemissasi listoissa');
      return;
    }

    var selected_lists_ids = selected_lists.map(x => x._id);

    var req = {
      lists: selected_lists_ids,
      userID: storable_profile._id
    }

    this.http.post(environment.SAVE_PROFILE_TO_LIST, req, this.httpOptions).subscribe(
      (res: any) => {
        if (res.status == 200) {
          console.log(res);
          document.getElementById('close-save-list').click();
        }
        else {
          console.log('buu')
        }

      }, (err: any) => {
        console.log(err)
      })
  }

  selectList(list) {

    for (let i = 0; i < this.employer_lists.length; i++) {
      var elm = this.employer_lists[i];

      if (elm._id == list._id) {
        elm.selected = !elm.selected;
      }

    }

  }

  createANewList() {
    var selected_right = this.rights.filter(x => x.selected == true);
    var title = (<HTMLInputElement>document.getElementById('list-title')).value;
    var description = (<HTMLInputElement>document.getElementById('list-description')).value;

    var req = {
      title: title,
      description: description,
      right: selected_right[0].id,
      profiles: [this.storable_profile._id],
      can_be_seen_by_others_in_same_business: selected_right[0].can_be_seen_by_others_in_same_business,
    }

    //Save list 

    this.http.post(environment.EMPLOYER_LISTS, req, this.httpOptions).subscribe(
      (res: any) => {
        if (res.status == 200) {
          console.log(res);
          document.getElementById('close_create_new_list').click();
          setTimeout(() => {
            document.getElementById('list-created').click();
          }, 100);
        }
        else {
          console.log('buu')
        }

      }, (err: any) => {

      }
    )
  }

  selectRight(right) {
    for (let i = 0; i < this.rights.length; i++) {
      const elm = this.rights[i];
      elm.selected = false;
    }

    for (let i = 0; i < this.rights.length; i++) {
      var elm = this.rights[i];
      if (elm == right) {
        elm.selected = true;
      }
    }

    console.log(this.rights)

  }

  addSingleProfileToList(data) {
    var profileID = data._id;
    var req = {
      profileID: profileID,
      listID: data._id
    }
  }

  removeItemFromList(item) {
    console.log(item, this.storable_profile);
    var req = {
      profileID: this.storable_profile._id,
      lists: [item.id]
    }

    this.http.post(environment.REMOVE_PROFILE_FROM_LIST, req, this.httpOptions).subscribe(
      (res: any) => {
        if (res.status == 200) {
          console.log(res);
          //Remove all lists from already_in_list
          for (let i = 0; i < this.already_in_list.length; i++) {
            var person = this.already_in_list[i];

            if (person.id == item.id) {
              this.already_in_list.splice(i, 1);
            }

          }
        }
        else {
          console.log('buu')
        }

      }, (err: any) => {

      }
    )

  }

  routeToLists(){
    //Close modal
    document.getElementById('close-list-created').click();
    //Route to lists
    this.router.navigate(['/' + this.businessID + '/lists']);
  }

  sendMessage() {

    var profilePicture;
    console.log(this.opening)
    profilePicture = this.opening.profile['profilePicture'];

    var req = {
      openingID: null,
      firstName: this.opening.profile.firstName,
      mdType: {},
      logo: this.opening.logo,
      userID: this.opening.profile._id,
      type: 'businessInterest',
      businessID: this.businessID,
      profilePicture: profilePicture,
    }

    this.http.post(environment.MESSAGE_LIST, req, this.httpOptions).subscribe(
      (res: any) => {
        if (res.status == 200) {
          this.routeMessages(res.message[0]._id)
        }
        else {
          console.log('buu')
        }

      }, (err: any) => {

      }
    )
  }

  routeMessages(id) {
    console.log(id);
    localStorage.setItem('ACTIVE_MSG_LIST', JSON.stringify(id));
    this.router.navigate(['/' + this.businessID + '/messages']);
  }

}
